/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import _ from 'lodash';
import {
  checkQuarterValidation,
  convertQuaterToDate,
  quarterTest1,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import MaxLengthNumericEditor from '../../../../SharedModules/CustomAgGridEditor/inputComponent';
import {
  DRUG_FAMILY_DESC_REQUIRED,
  DRUG_FAMILY_NAME_REQUIRED,
  MFG_ID_FOR_CONTRACT,
  MFG_NAME_FOR_CONTRACT,
  PLAN_TYPE_DESC_REQUIRED,
  PLAN_TYPE_REQUIRED,
  QUARTER_VALUE_REQUIRED,
  REBATE_PGM_CODE_DESC_REQUIRED,
  REBATE_PROG_CD_REQ,
  OVERLAP_ERR_PRICE_LEVEL,
} from '../../../../SharedModules/Errors/constantMessageData';
import * as Styles from '../../../../SharedModules/StyleConstant/StyleConstant';
import { storeBlurState, storeOverlapState } from '../store/actions';

export const priceDetailsInputFields = [
  {
    label: 'Plan Type',
    name: 'planType',
    errMsg: PLAN_TYPE_REQUIRED,
    maxLength: false,
  },
  {
    label: 'Plan Type Description',
    name: 'planTypeDesc',
    errMsg: PLAN_TYPE_DESC_REQUIRED,
    maxLength: false,
  },
  {
    label: 'Rebate Program Code',
    name: 'rebatePgmCode',
    errMsg: REBATE_PROG_CD_REQ,
    maxLength: 38,
  },
  {
    label: 'Rebate Program Code Decription',
    name: 'rebatePgmCodeDesc',
    errMsg: REBATE_PGM_CODE_DESC_REQUIRED,
    maxLength: false,
  },
  {
    label: 'Manufacturer ID',
    name: 'manufactId',
    errMsg: MFG_ID_FOR_CONTRACT,
    maxLength: 10,
  },
  {
    label: 'Manufacturer Name',
    name: 'manufactName',
    errMsg: MFG_NAME_FOR_CONTRACT,
    maxLength: false,
  },
  {
    label: 'Quarter',
    name: 'quarter',
    errMsg: QUARTER_VALUE_REQUIRED,
    maxLength: 6,
  },
  {
    label: 'Drug Family Name',
    name: 'drugFamilyName',
    errMsg: DRUG_FAMILY_NAME_REQUIRED,
    maxLength: 120,
  },
  {
    label: 'Drug Family Description',
    name: 'drugFamilyDesc',
    errMsg: DRUG_FAMILY_DESC_REQUIRED,
    maxLength: 255,
  },
];

export const tableData = [
  {
    mfgId: '00003',
    mfgName: 'sample data',
    mfgTypeCd: 'C',
    defEnrollmentTimingCd: '-1',
    defPricingTimingCd: '-1',
    defCollectionMediumCd: null,
    defPaperFinalQtr: null,
    defPrintImageFinalQtr: null,
    defCmsElectFinalQtr: null,
    defNcpdpSummaryFinalQtr: null,
    defNcpdpClaimOwnFinalQtr: null,
    defNcpdpClaimMbFinalQtr: null,
    defPaperInd: 0,
    defPrintImageInd: null,
    defCmsElectInd: 1,
    defNcpdpSummaryInd: 0,
    defNcpdpClaimOwnInd: 0,
    defNcpdpClaimMbInd: 0,
    addrDiscrepancyInd: null,
    rebatewebParticipantInd: null,
    defWacPct: null,
    lastUpdateDt: 1672631760000,
    lastUpdateUserId: 'DRAMS',
    corrLinkId: 68,
    shortDescr: null,
    contractSeqNum: null,
  },
  {
    mfgId: '00004',
    mfgName: 'sample data',
    mfgTypeCd: 'C',
    defEnrollmentTimingCd: 'END',
    defPricingTimingCd: 'AVG',
    defCollectionMediumCd: null,
    defPaperFinalQtr: null,
    defPrintImageFinalQtr: null,
    defCmsElectFinalQtr: null,
    defNcpdpSummaryFinalQtr: null,
    defNcpdpClaimOwnFinalQtr: null,
    defNcpdpClaimMbFinalQtr: null,
    defPaperInd: 1,
    defPrintImageInd: null,
    defCmsElectInd: 1,
    defNcpdpSummaryInd: 1,
    defNcpdpClaimOwnInd: 1,
    defNcpdpClaimMbInd: 0,
    addrDiscrepancyInd: null,
    rebatewebParticipantInd: null,
    defWacPct: 123,
    lastUpdateDt: 1672631760000,
    lastUpdateUserId: 'DRAMS',
    corrLinkId: 77,
    shortDescr: null,
    contractSeqNum: null,
  },
];

export const pricingDataTableHead = [
  {
    headerName: 'Rebate Pricing Method',
    field: 'rebatePricingMethodCd',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_240,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    sortingOrder: ['desc', 'asc'],
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Volume Calc Method',
    field: 'volumeCalcMethodCd',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_240,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    sortingOrder: ['desc', 'asc'],
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Market Share Calc Method',
    field: 'mktShareCalcMethodCd',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_250,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    sortingOrder: ['desc', 'asc'],
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'National Mkt Share Type',
    field: 'natMktShareTypeCd',
    editable: false,
    sortable: true,
    minWidth: Styles.Width_250,
    cellRenderer: 'TextBoxRender',
    cellEditor: MaxLengthNumericEditor,
    maxLength: 10,
    isNumber: true,
    // cellEditorParams: {
    //   maxLength: 8,
    //   custWidth: '135px',
    // },
    resizable: false,
    // custClass: 'tbill-rate-editable-input',
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    sortingOrder: ['desc', 'asc'],
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const levelDetailTableHead = [
  {
    headerName: 'Comments Exists',
    cellClass: 'frr-overflow-visible',
    field: 'ccCommentsExist',
    filter: false,
    sortable: false,
    enableMenu: false,
    showCheckboxIcon: true,
    // minWidth: Styles.Width_100,
    minWidth: Styles.Width_200,
    // maxWidth: Styles.Width_130,
    resizable: true,
    editable: false,
    suppressMenu: false,
    // pinned: 'left',
    // lockPinned: true,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'ActionCellRender',
    cellStyle: { 'border-right-color': Styles.BorderColor },
  },
  {
    headerName: 'Level ID',
    field: 'levelId',
    cellClass: 'frr-input-top-2',
    editable: false,
    sortable: true,
    cellRenderer: 'TextBoxRender',
    minWidth: Styles.Width_171,
    cellEditor: MaxLengthNumericEditor,
    // maxLength: 10,
    isNumber: true,
    resizable: false,
    filter: 'agTextColumnFilter',
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Level Amount',
    field: 'levelAmt',
    editable: false,
    cellClass: 'frr-input-top-2 frr-amount-prefix',
    sortable: true,
    exportZeroesTwo: true,
    cellRenderer: 'TextBoxRender',
    cellEditor: MaxLengthNumericEditor,
    // maxLength: 10,
    minWidth: Styles.Width_171,
    isNumber: true,
    resizable: false,
    filter: 'agTextColumnFilter',
    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    dataAlignRight: true,
    printPrefixValue: '$ ',
  },
  {
    headerName: 'Level Pct',
    field: 'levelPct',
    cellClass: 'frr-input-top-2',
    editable: false,
    sortable: true,
    cellRenderer: 'TextBoxRender',
    minWidth: Styles.Width_171,
    cellEditor: MaxLengthNumericEditor,
    maxLength: 10,
    isNumber: true,
    resizable: false,
    filter: 'agTextColumnFilter',
    excelAlignment: 'right',
    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    dataAlignRight: true,
  },
  {
    headerName: 'Rebate Pct',
    field: 'rebatePct',
    editable: false,
    sortable: true,
    cellRenderer: 'TextBoxRender',
    minWidth: Styles.Width_171,
    cellEditor: MaxLengthNumericEditor,
    maxLength: 10,
    isNumber: true,
    resizable: false,
    filter: 'agTextColumnFilter',
    excelAlignment: 'right',
    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    dataAlignRight: true,
  },
  {
    headerName: 'Start Quarter',
    field: 'startQtr',
    editable: false,
    sortable: true,
    cellRenderer: 'TextBoxRender',
    minWidth: Styles.Width_171,
    cellEditor: MaxLengthNumericEditor,
    maxLength: 10,
    isNumber: true,
    resizable: false,
    filter: 'agTextColumnFilter',
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'End Quarter',
    field: 'endQtr',
    editable: false,
    sortable: true,
    cellRenderer: 'TextBoxRender',
    minWidth: Styles.Width_171,
    cellEditor: MaxLengthNumericEditor,
    maxLength: 10,
    isNumber: true,
    resizable: false,
    filter: 'agTextColumnFilter',
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const drugFamilyTableData = [
  {
    headerName: 'Drug Family ID',
    field: 'familySeqNum',
    editable: false,
    sortable: true,
    suppressMenu: false,
    sort: 'asc',
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    excelAlignment: 'right',
    cellStyle: { textAlign: 'right', 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Drug Family Name',
    field: 'familyName',
    editable: false,
    sortable: true,
    resizable: false,
    suppressMenu: false,
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const manuFactureHead = [
  {
    headerName: 'Manufacturer ID',
    field: 'mfgId',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    sort: 'asc',
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Manufacturer Name',
    field: 'mfgName',
    editable: false,
    sortable: true,
    resizable: false,
    suppressMenu: false,
    minWidth: Styles.Width_250,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const planTypeData = [
  {
    name: 'Commercial',
    value: 'COMM',
  },
  {
    name: 'Supplemental',
    value: 'SUPP',
  },
];
export const drugData = [
  {
    name: 'Select A Drug Family',
    value: 'drug',
  },
  {
    name: 'All',
    value: 'all',
  },
];

export const levelValidation = (array = []) => {
  const temp = array.map((item) => item.levelId === '');
  return temp.includes(true);
};

export const seperateLevels = (array, key) => {
  return array.reduce(function (rv, x) {
    (rv[x[key]] = rv[x[key]] || []).push(x);
    return rv;
  }, {});
};

const count = (arr = []) =>
  arr.reduce(
    (result, value) => ({ ...result, [value]: (result[value] || 0) + 1 }),
    {}
  );

export const quarterOverlapValidation = (array = []) => {
  const data = seperateLevels(array, 'levelId');
  const keys = Object.keys(data);
  const booleanArr = keys.map((item) => {
    const dd = data[item];
    const unique = dd
      .filter((item2) => quarterTest1.test(item2.startQtr))
      .map((item3) => item3.startQtr);
    const isDuplicate = count(unique);
    return isDuplicate;
  });
  // returns array i.e ['true', 'false'] if true then same qtr exist for same levelId
  return booleanArr;
};

export const isStartQtrValid = (array = []) => {
  const temp = array.map((item) => checkQuarterValidation(item.startQtr));
  return temp.includes(false);
};

export const endQtrValidation = (array = []) => {
  const temp = array.map((item) => item.endQtr === '');
  return temp.includes(true);
};

export const startQtrValidation = (array = []) => {
  const temp = array.map((item) => item.startQtr === '');
  return temp.includes(true);
};

export const generateQuarter = (d) => {
  var date = new Date();
  var month = date.getMonth() + 1;
  var year = date.getFullYear();
  let quarter = Math.ceil(month / 3);
  return `${quarter}Q${year}`;
};

export const getGridTwo = (priceDetailGrids) => {
  if (priceDetailGrids && Object.keys(priceDetailGrids).length > 0) {
    const { getDetailsGridTwo } = priceDetailGrids.rebateProgramLevel[0];
    const arr =
      getDetailsGridTwo.length > 0 &&
      getDetailsGridTwo.map((item, index) => {
        return {
          ...item,
          endQtr: item.endQtr ? item.endQtr : null,
          ccCommentsExist: item.ccCommentsExist,
          deleteRecord: 0,
          rowIndex: index,
        };
      });
    return Array.isArray(arr) ? arr : [];
  }
};

export const clearCellErrors = (blurPageState, overlapStateErr, dispatch) => {
  // clear cell errors
  let errors = [...blurPageState];
  errors = errors.map((item) => {
    return {
      ...item,
      startQtrErr: false,
      endQtrErr: false,
      rangeInvalidErr: false,
      levelIdErr: false,
      invalidStartQtrErr: false,
    };
  });
  dispatch(storeBlurState(errors));

  // clear overlap cell errors
  let overlapErrs = [...overlapStateErr];
  overlapErrs = overlapErrs.map((item) => {
    return {
      ...item,
      startQtrOverlap: false,
      startQtrErr: false,
      endQtrErr: false,
      rangeInvalidErr: false,
      levelIdErr: false,
      invalidStartQtrErr: false,
    };
  });
  dispatch(storeOverlapState(overlapErrs));
};

const checkOverlapIndices = (arr) => {
  let overlaps = [];
  for (let i = 0; i < arr.length - 1; i++) {
    const { levelId: id1, startQtr: start1, endQtr: end1 } = arr[i];
    if (start1 && end1) {
      for (let j = i + 1; j < arr.length; j++) {
        const { levelId: id2, startQtr: start2, endQtr: end2 } = arr[j];
        if (id1 === id2 && start2 && end2 && start1 <= end2 && start2 <= end1) {
          overlaps.push(i, j);
        }
      }
    }
  }
  return (overlaps = [...new Set(overlaps)]);
};

export const doQuartersOverlap = (
  localErr,
  cellInfo,
  getInputValues,
  array,
  dispatch
) => {
  let temp = [...array];
  temp = temp.map((el) => {
    return {
      ...el,
      startQtr: quarterTest1.test(el.startQtr)
        ? new Date(convertQuaterToDate(el.startQtr))
        : false,
      endQtr: quarterTest1.test(el.endQtr)
        ? new Date(convertQuaterToDate(el.endQtr))
        : el.endQtr === null || el.endQtr === ''
        ? new Date('12/31/9999')
        : false,
    };
  });

  localErr = localErr.filter((e) => e.field !== 'overlap');
  let overlappedRows = checkOverlapIndices(temp);
  const filteredRows =
    overlappedRows.length > 0
      ? array.map((row, index) => {
          if (overlappedRows.includes(row.rowIndex)) {
            if (overlappedRows.length) {
              localErr.push({
                field: 'overlap',
                errorType: `overlap${cellInfo.rowIndex}`,
                rowIndex: index,
                message: OVERLAP_ERR_PRICE_LEVEL(
                  getInputValues.currheaderArray?.familyName,
                  getInputValues.getDetailsGridOne[0]?.rebatePricingMethodCd,
                  row.levelId,
                  index + 1
                ),
              });
            } else {
              localErr = localErr.filter((e) => e.field !== 'overlap');
            }
            return {
              ...row,
              startQtrOverlap: true,
            };
          } else return row;
        })
      : [];
  dispatch(storeOverlapState(filteredRows));
  return localErr;
};
